// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/** Which log a list, an entry popup or an export is about. */
export var ELogScope;
(function (ELogScope) {
    /** An election event's log. */
    ELogScope["EVENT"] = "event";
    /** The tenant log (Settings > Logs). */
    ELogScope["TENANT"] = "tenant";
})(ELogScope || (ELogScope = {}));
/** The react-admin `meta` key that carries the scope to the data provider. */
export var LOG_SCOPE_META = "logScope";
/** The statement kinds the tenant log holds. */
export var TENANT_LOG_STATEMENT_KINDS = [
    "KeycloakUserEvent",
    "AdminChange",
    "TenantAdminAction",
    "KeycloakAdminEvent",
    "LogsExported",
    "LogWriterStarted",
    "LogWriterStopped",
    "AdminPublicKey",
];
export var LOG_EVENT_TYPES = ["USER", "SYSTEM"];
export var LOG_TYPES = ["INFO", "ERROR"];
export var LOG_FILTER_EVENT_TYPE = "event_type";
export var LOG_FILTER_LOG_TYPE = "log_type";
/** Below this width of the list, Created starts hidden under Columns. */
export var LOG_LIST_WIDE = 1500;
/** Below this width of the list, each entry is two lines. */
export var LOG_LIST_COMPACT = 1000;
export var ELogListLayout;
(function (ELogListLayout) {
    ELogListLayout["WIDE"] = "wide";
    ELogListLayout["MEDIUM"] = "medium";
    ELogListLayout["COMPACT"] = "compact";
})(ELogListLayout || (ELogListLayout = {}));
/** The layout of a list that is `width` pixels wide; wide until it is measured. */
export var logListLayout = function (width) {
    if (width === null || width >= LOG_LIST_WIDE)
        return ELogListLayout.WIDE;
    return width >= LOG_LIST_COMPACT ? ELogListLayout.MEDIUM : ELogListLayout.COMPACT;
};
